import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const YachtTrackPage = withSuspense(
	lazy(async () => await import('./yacht-track-page.component')),
	PageLoader,
);
